import { DateTime } from "luxon";

/** Uses the practice's calendar day, not a rolling 24-hour window. */
export function isSameDayEligibilityCheck(createdAt: string, timezone: string, now: string): boolean {
  const checkedAt = DateTime.fromISO(createdAt, { zone: timezone });
  const currentTime = DateTime.fromISO(now, { zone: timezone });

  return (
    checkedAt.isValid &&
    currentTime.isValid &&
    checkedAt <= currentTime &&
    checkedAt.toISODate() === currentTime.toISODate()
  );
}
